import { createFileRoute } from "@tanstack/react-router";
import { ProjektoekonomiPage, projektoekonomiHead } from "@/pages/ProjektoekonomiPage";

export const Route = createFileRoute("/en/project-economics")({
  head: () => projektoekonomiHead("en"),
  component: () => <ProjektoekonomiPage locale="en" />,
});
